import { render, staticRenderFns } from "./TrackingShippingCompanyLayout.vue?vue&type=template&id=646e9340"
import script from "./TrackingShippingCompanyLayout.vue?vue&type=script&lang=js"
export * from "./TrackingShippingCompanyLayout.vue?vue&type=script&lang=js"
import style0 from "./TrackingShippingCompanyLayout.vue?vue&type=style&index=0&id=646e9340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports